import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import { useI18n } from '@mssgme/i18n';
import { SplashScreen, useUITranslations } from '@mssgme/ui';
import { useAuth, useUtmStore } from '@mssgme/hooks';
import {
    JoinCodeAuthPage,
    LoginCodeAuthPage,
    LoginPage,
    LogoutPage,
    PrivateRoute,
    RegistrationPage,
    RestorePage,
    RestorePasswordAuth,
} from './Pages';

function LocalesLoader({ children }) {
    useI18n('auth', (language) =>
        import(
            /* webpackChunkName: "locales.auth" */
            /* webpackInclude: /\.json$/ */
            `../../locales/${language}/auth.json`
        )
    );
    useUITranslations();

    return children;
}

function PublicRoute(props) {
    const { isAuthenticated } = useAuth();

    if (isAuthenticated) {
        window.location.replace('/');
    }

    return <Route {...props} />;
}

export const AuthRoutes = () => {
    // useUtmStore here and not inside AuthApp directly, because useLocation inside useUtmStore requires router context
    useUtmStore();

    return (
        <Switch>
            <Route exact path="/reset-password/:code" component={RestorePasswordAuth} />
            <Route exact path="/join/:code" component={JoinCodeAuthPage} />
            <Route exact path="/login/code/:code" component={LoginCodeAuthPage} />
            <PublicRoute exact path="/login" component={LoginPage} />
            <PublicRoute exact path="/signup" component={RegistrationPage} />
            <PublicRoute exact path="/restore" component={RestorePage} />
            <Route exact path="/sso/login" component={LoginPage} />
            <Route exact path="/sso/signup" component={RegistrationPage} />
            <Route exact path="/sso/restore" component={RestorePage} />
            <PrivateRoute exact path="/logout" component={LogoutPage} />
            <Redirect to="/login" />
        </Switch>
    );
};

export default function AuthApp({ store }) {
    return (
        <Suspense fallback={<SplashScreen />}>
            <LocalesLoader>
                <Provider store={store}>
                    <BrowserRouter basename="/auth">
                        <AuthRoutes />
                    </BrowserRouter>
                </Provider>
            </LocalesLoader>
        </Suspense>
    );
}

AuthApp.propTypes = {
    store: PropTypes.object.isRequired,
};
